import {cs}                from "@Common/react/chain-services";
import {scopedState}       from "@Common/react/scoped-state";
import {Static2}           from "@Common/react/static-2";
import {UseState}          from "@Common/react/use-state";
import {changeNestedValue} from "@Common/utils/arr-path";
import {unique}            from "@Common/utils/collections";
import {chain}             from "@Common/utils/fs";
import {omit}              from "@Common/utils/objects";

import {ErrorHighlighter} from "../../../light/error-highlighter";
import {scrollIntoView}   from "../../../light/scroll-into-view";

import {setCurrentToSaved} from "./set-current-to-saved";

export const DownloadDeliveryLogic = ({item, templateOptions, next: rootNext}) => cs(
    ["state", (_, next) => UseState({
        getInitValue: () => chain(
            item?.selections?.fileType,
            (_) => ({
                saved  : _,
                current: _,
            }),
        ),
        next,
    })],

    ["eh", (_, next) => ErrorHighlighter({next})],
    ["domRef", (_, next) => Static2({next})],

    ["step1", ({}, next) => rootNext({
        cleanItem: (item) => changeNestedValue(item, ["selections"], (_) => omit(_, ["fileType"])),
        next,
    })],

    ["fileTypes", (_, next) => next(getFileTypes(templateOptions))],
    ["fileType", ({state, fileTypes}, next) => next(
        state.value.current ??
        fileTypes.find((t) => t === "jpg")
        ?? fileTypes[0]
    )],

    ({step1, state, fileTypes, fileType, eh, domRef}) => step1.next({
        itemEditor: {
            $name: "download delivery",
            prepareSave: (item) => ({
                newValue: changeNestedValue(item, ["selections", "fileType"], (_) => fileType),
                onSaved: () => setCurrentToSaved(state),
            }),

            changed: state.value.saved !== state.value.current,

            errorsHandling: {
                highlightErrors: () => {
                    eh.start();
                    scrollIntoView(domRef.get());
                },
            },

            valid: !!step1.paperPrice && !!fileTypes.length,
        },

        ui: {
            fileTypes,
            paperPrice: step1.paperPrice,
            urls: item?.metaData?.ccReferenceURLs,
            state: chain(
                scopedState(state, ["current"]),
                (s) => ({...s, value: s.value ?? fileType})
            ),

            eh, domRef,
        },
    }),
);


const getFileTypes = (templateOptions, method="download") => {
    let fileTypes = [];
    for (let i = 0; i < templateOptions.options.length; i++) {
        const option = templateOptions.options[i];
        if (option.dev_key === "pdf_download" && ~option.distributionFilter.indexOf(method)) {
            fileTypes.push("pdf");
        }
        if ((option.dev_key ?? option.devKey) === "enable_jpg_download" && ~option.distributionFilter.indexOf(method)) {
            fileTypes.push("jpg");
        }
    }
    return unique(fileTypes);
};